import { render, staticRenderFns } from "./AccountInstagramSelect.vue?vue&type=template&id=bc23584a"
import script from "./AccountInstagramSelect.vue?vue&type=script&lang=js"
export * from "./AccountInstagramSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports